import React, { useEffect } from 'react';

const AdComponent = ({ adSlot, adFormat = 'auto', fullWidthResponsive = true, style = { display: 'block' } }) => {
  useEffect(() => {
    try {
      const adsbygoogle = window.adsbygoogle || [];
      // Only push if there's an ad slot that hasn't been initialized
      if (adsbygoogle.length >= 0) {
        adsbygoogle.push({});
      }
    } catch (e) {
      if (e.message.includes('adsbygoogle.push() error: All \'ins\' elements in the DOM with class=adsbygoogle already have ads in them.')) {
        // Silently ignore this specific error as it's common in React re-renders
        return;
      }
      console.error('AdSense error:', e.message);
    }
  }, [adSlot]);

  return (
    <div className="ad-container my-8 flex justify-center w-full overflow-hidden">
      <ins
        className="adsbygoogle"
        style={style}
        data-ad-client="ca-pub-8307284067221869"
        data-ad-slot={adSlot}
        data-ad-format={adFormat}
        data-full-width-responsive={fullWidthResponsive.toString()}
      ></ins>
    </div>
  );
};

export default AdComponent;
